/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustadd2Inputs */

const zh_adminsubs_adjustadd2 = /** @type {(inputs: Adminsubs_Adjustadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增加`)
};

const en_adminsubs_adjustadd2 = /** @type {(inputs: Adminsubs_Adjustadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const es_adminsubs_adjustadd2 = /** @type {(inputs: Adminsubs_Adjustadd2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Adminsubs_Adjustadd2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustadd2 = /** @type {((inputs?: Adminsubs_Adjustadd2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustadd2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustadd2(inputs)
	if (locale === "en") return en_adminsubs_adjustadd2(inputs)
	return es_adminsubs_adjustadd2(inputs)
});
export { adminsubs_adjustadd2 as "adminSubs_adjustAdd" }